import React from 'react'
import Routes from './routes/Routes'
import i18n from './utils/i18n';
import { I18nextProvider } from 'react-i18next';
import Layout from './components/Layout';

const App = () => {
  return (
    <I18nextProvider i18n={i18n}>
      <Layout>
      <Routes />
      </Layout>

    </I18nextProvider>
  )
}

export default App